import React from 'react'
import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material'
import { Close, ShoppingCart } from '@mui/icons-material'
import { usePalworldCart } from '../../../contexts/PalworldCartContext'
import PalworldCartItem from './PalworldCartItem'
import PalworldCartSummary from './PalworldCartSummary'

const PalworldCartDrawer: React.FC = () => {
  const { state, toggleCart } = usePalworldCart()

  return (
    <Drawer
      anchor="right"
      open={state.isOpen}
      onClose={toggleCart}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 480 },
          backgroundColor: 'rgba(12, 13, 24, 0.98)',
          borderLeft: '1px solid rgba(0,230,118,0.18)'
        }
      }}
      transitionDuration={250}
    >
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            p: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid rgba(255,255,255,0.08)'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
            <ShoppingCart sx={{ color: '#00e676' }} />
            <Typography variant="h6" fontWeight={900}>
              Carrinho (Itens Palworld)
            </Typography>
          </Box>
          <IconButton onClick={toggleCart} sx={{ color: 'text.secondary' }}>
            <Close />
          </IconButton>
        </Box>

        <Box sx={{ flex: 1, overflow: 'hidden' }}>
          {state.items.length === 0 ? (
            <Box sx={{ p: 4, textAlign: 'center' }}>
              <Typography variant="h6" sx={{ fontWeight: 900, mb: 1 }}>
                Carrinho vazio
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                Selecione um item e adicione uma quantidade ao carrinho.
              </Typography>
            </Box>
          ) : (
            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Box
                sx={{
                  flex: 1,
                  overflowY: 'auto',
                  px: 2,
                  py: 1.5,
                  '&::-webkit-scrollbar': { width: 6 },
                  '&::-webkit-scrollbar-thumb': { bgcolor: '#00e676', borderRadius: 3 }
                }}
              >
                <Stack spacing={0.5}>
                  {state.items.map((line) => (
                    <PalworldCartItem key={line.id} line={line} />
                  ))}
                </Stack>
              </Box>

              <Box sx={{ p: 2, borderTop: '1px solid rgba(255,255,255,0.08)', bgcolor: 'rgba(0,0,0,0.18)' }}>
                <PalworldCartSummary />
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Drawer>
  )
}

export default PalworldCartDrawer

